// The one place that reads config.apiBase, so a stale frontend/src/config.js
// (copied before the apiBase-only shape existed, e.g. still exporting
// { host, backendPort }) degrades to "" everywhere instead of letting
// "undefined" leak into request URLs ("undefined/api/chat", …).
import config from "../config";

const apiBase = () => (typeof config.apiBase === "string" ? config.apiBase : "");

export default apiBase;
